import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../services/modal.service';
import { Observable, forkJoin } from 'rxjs';
import { share } from 'rxjs/operators';
import { I18nTranslator } from '../../i18n/translate';
import { ARBleCampaign, ARBleOrderItem, ARBleParcel } from '../../models/agrorendement-ble.model';
import { ARColzaCampaign, ARColzaOrderItem, ARColzaParcel } from '../../models/agrorendement-colza.model';
import { AROrgeCampaign, AROrgeOrderItem, AROrgeParcel } from '../../models/agrorendement-orge.model';
import { Campaign } from '../../models/campaign.model';
import { Farm } from '../../models/farm.model';
import { Organisation } from '../../models/organisation.model';
import { Parcel } from '../../models/parcel.model';
import { TranslateDatePipe, TranslatePipe, TranslateWithPunctuationPipe } from '../../pipes/translate.pipe';
import { ARBleService } from '../../services/agrorendement-ble.service';
import { ARColzaService } from '../../services/agrorendement-colza.service';
import { AROrgeService } from '../../services/agrorendement-orge.service';
import { KeycloakService } from '../../services/keycloak.service';
import { OrganisationService } from '../../services/organisation.service';
import { PlanningService } from '../../services/planning.service';
import { UserService } from '../../services/user.service';
import { showErrorMessage } from '../../utils/utils';
import { PlanningSelectExploitation } from './planning-exploitation.component';
import { PlanningSelectParcel } from './planning-parcel.component';
import { PlanningCalendar } from './planning-visualizer/planning-calendar.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

enum stepPlanningEnum {
  STEP_SELECT_OAD,
  STEP_SELECT_FARMS,
  STEP_PLANNING_PICKER,
  STEP_SELECT_PARCEL,
}

@Component({
  standalone: true,
  selector: 'planning-choice',
  templateUrl: 'planning-choice.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, PlanningSelectExploitation, PlanningCalendar, TranslatePipe, TranslateWithPunctuationPipe, TranslateDatePipe, CommonModule, FormsModule, BsDatepickerModule],
  providers: [
    UserService,
    OrganisationService,
    PlanningService,
    ARBleService,
    ARColzaService,
    AROrgeService,
    TranslateDatePipe,
  ],
})
export class PlanningChoiceComponent implements OnInit, OnDestroy {
  @ViewChild(PlanningSelectExploitation)
  private planningSelectExploitation: PlanningSelectExploitation;

  @ViewChild(PlanningCalendar)
  private planningSelectParcel: PlanningCalendar;

  stepPlanning = stepPlanningEnum;
  step: stepPlanningEnum;

  organisation: Array<Organisation> = [];
  // param
  culture: string;
  // pour affichage
  cultureLabel: string;
  sub: any;
  passage: string = null;
  enumPassage: any[];
  farmIds = new Set<number>();
  farmIdMapping = new Map<number, string>();
  parcelIds = new Set<number>();
  parcelIdMapping = new Map<number, string>();
  farms = new Array<Farm>();
  parcels = new Array<Parcel>();
  planningLink = ['/planning'];
  isFarm: boolean = false;
  colzaCulture: boolean = false;
  objectList: Map<number, string>;
  date: Date;
  dateChoiceTitle: string;
  objectListName: string = '';
  farmParcelIndex = new Map<number, Array<Parcel>>();
  public isAdmin: boolean;
  changeSomeParcel: boolean = true;
  organisationChoice: any;

  public campaignFilter: number;
  campaignsOrge: AROrgeCampaign[];
  campaignsBle: ARBleCampaign[];
  campaignsColza: ARColzaCampaign[];

  constructor(
    public datepipe: TranslateDatePipe,
    private colzaService: ARColzaService,
    private bleService: ARBleService,
    private orgeService: AROrgeService,
    private planningService: PlanningService,
    protected i18nTranslator: I18nTranslator,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
  }

  //angular Cycle de vie
  ngOnInit() {
    const obs1 = this.getBleCampaigns();
    const obs2 = this.getOrgeCampaigns();
    const obs3 = this.getColzaCampaigns();

    forkJoin([obs1, obs2, obs3]).subscribe((data: Array<any>) => {
      let temp: any;
      if (this.culture === 'ble') {
        temp = data[0];
        this.campaignFilter = temp[0].id;
      } else if (this.culture === 'orge') {
        temp = data[1];
        this.campaignFilter = temp[0].id;
      } else if (this.culture === 'colza') {
        temp = data[2];
        this.campaignFilter = temp[0].id;
        this.colzaCulture = true;
      }
    });
    this.sub = this.route.params.subscribe((params) => {
      this.culture = params['culture'];
      this.cultureLabel = this.i18nTranslator.translate('planning.culture.' + this.culture);
    });
    // si on repasse par le bouton planning ou que l'on change de culture on reset les filtres
    if (PlanningSelectExploitation) {
      PlanningSelectExploitation.filterToApply = null;
    }
    if (PlanningCalendar) {
      PlanningCalendar.filterToApply = null;
    }
    this.step = this.stepPlanning.STEP_SELECT_OAD;

    if (this.culture === 'ble') {
      this.enumPassage = [
        { id: 'blet1', value: 'BLET1', label: this.i18nTranslator.translate('planning.label.ble.t1') },
        { id: 'blet2', value: 'BLET2', label: this.i18nTranslator.translate('planning.label.ble.t2') },
        { id: 'blet3', value: 'BLEDN', label: this.i18nTranslator.translate('planning.label.ble.2n') },
        { id: 'blet4', value: 'BLET3', label: this.i18nTranslator.translate('planning.label.ble.t3') },
      ];
    }
    if (this.culture === 'orge') {
      this.enumPassage = [
        { id: 'orget2', value: 'ORGET2', label: this.i18nTranslator.translate('planning.label.orge.t2') },
        { id: 'orget3', value: 'ORGET3', label: this.i18nTranslator.translate('planning.label.orge.t3') },
      ];
    }
    if (this.culture === 'colza' && this.isAdmin) {
      this.enumPassage = [
        { id: 'colzaEh', value: 'COLZAEH', label: this.i18nTranslator.translate('planning.label.colza.eh') },
        { id: 'colzash', value: 'COLZASH', label: this.i18nTranslator.translate('planning.label.colza.sh') },
      ];
    }
    if (this.culture === 'colza' && !this.isAdmin) {
      this.enumPassage = [
        { id: 'colzash', value: 'COLZASH', label: this.i18nTranslator.translate('planning.label.colza.sh') },
      ];
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  keepOrganisation(organisation: any) {
    if (typeof organisation == 'string') {
      if (organisation == 'null') {
        this.organisationChoice = null;
        return;
      }
      const number = parseInt(organisation);
      this.organisationChoice = number;
    } else if (Array.isArray(this.organisation)) {
      if (this.organisation.length == 0) {
        this.organisation = this.organisation.concat(organisation);
      }
    }
  }
  //get Data
  getParcels() {
    const farmIds_arr = this.farms.map((farm) => farm.id);
    farmIds_arr.forEach((el) => {
      this.planningService
        .getParcelsFarms(this.culture, this.passage, this.campaignFilter, [el], null, null, null, null, false)
        .subscribe(
          (parcels: Parcel[]) => {
            this.handleParcels(parcels);
          },
          (e) => {
            this.handleErroWhitMsg(e, this.i18nTranslator.translate('planning.error.parcelles'));
          },
        );
    });
  }

  handleParcels(parcels: Parcel[]) {
    this.parcels.push(...parcels);
  }
  // a changer
  handleError(e: any) {
    this.modal.alert(this.i18nTranslator.translate('planning.error.info'));
  }

  handleErroWhitMsg(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('planning.error.unauthorized'));
    } else {
      console.error(error);
      // generic error message
      showErrorMessage(this.modal, msg);
    }
  }

  getUpdateParcels() {
    const farmIds_arr = this.farms.map((farm) => farm.id);
    this.planningService
      .getParcelsFarms(this.culture, this.passage, this.campaignFilter, farmIds_arr, null, null, null, null, false)
      .subscribe({
        next: (parcels: Parcel[]) => {
          ((this.parcels = new Array<Parcel>()), this.handleParcels(parcels));
        },
        error: (err) => {
          (this.handleErroWhitMsg(err, this.i18nTranslator.translate('planning.error.parcellesUpdate')),
            console.log(err));
        },
        complete: () => {
          this.step = this.stepPlanning.STEP_SELECT_PARCEL;
        },
      });
  }

  //Front
  getPassageLabel() {
    if (this.passage) {
      const recherche = this.enumPassage.filter((obj) => {
        if (obj.value == this.passage) return obj;
      });
      return recherche[0].label;
    }
  }
  onDatePicker() {
    this.date = null;
    if (this.isFarm) {
      this.dateChoiceTitle = this.i18nTranslator.translate('planning.datepicker.exploitations.title');
    } else {
      this.dateChoiceTitle = this.i18nTranslator.translate('planning.datepicker.parcelles.title');
    }
    this.objectListName = '';
    this.objectList.forEach((element) => {
      this.objectListName === '' ? (this.objectListName += element) : (this.objectListName += ', ' + element);
    });
  }

  //update
  modifierDate(parcel: Parcel) {
    this.changeSomeParcel = false;
    const setDate = new Map<number, string>();
    setDate.set(parcel.id, parcel.name);
    this.objectList = setDate;
    this.onDatePicker();
    this.step = this.stepPlanning.STEP_PLANNING_PICKER;
  }

  modifierSelection() {
    this.changeSomeParcel = true;
    this.objectList = this.parcelIdMapping;
    this.onDatePicker();
    this.step = this.stepPlanning.STEP_PLANNING_PICKER;
  }

  //Step
  stepselectOAD() {
    this.step = this.stepPlanning.STEP_SELECT_OAD;
  }

  nextStepSelectOAD() {
    console.log('seleccionar explotacion');
    this.step = this.stepPlanning.STEP_SELECT_PARCEL;
  }

  nextStepSelectFarms() {
    this.farms = new Array<Farm>();
    this.parcels = new Array<Parcel>();
    this.modal.confirm(this.i18nTranslator.translate('planning.livraison.choix')).then((confirmed) => {
      if (confirmed) {
        this.yesModal();
      } else {
        this.noModal();
      }
    });
    this.farms.splice(0, this.farms.length);
    this.farmIdMapping.forEach((name, keyId) => {
      const farm = new Farm();
      farm.id = keyId;
      farm.name = name;
      this.farms.push(farm);
    });

    this.getParcels();
  }

  nextStepSelectParcel() {
    this.farmIds = new Set<number>();
    this.farmIdMapping = new Map<number, string>();
    this.objectList = new Map<number, string>();
    this.parcelIds = new Set<number>();
    this.parcelIdMapping = new Map<number, string>();
    if (PlanningCalendar) {
      PlanningCalendar.filterToApply = null;
    }
    this.step = this.stepPlanning.STEP_SELECT_FARMS;
  }

  nextStepPicker() {
    this.date.setHours(2);
    let parcelToChange: any;
    if (this.isFarm) {
      this.parcels.forEach((parcel) => {
        if (this.culture === 'ble') {
          parcelToChange = parcel as ARBleParcel;
          this.bleService.getOrderItem(parcelToChange.orderItem.id).subscribe((orderItem: ARBleOrderItem) => {
            switch (this.passage) {
              case 'BLET1':
                if (
                  this.notInPastOrderItem(orderItem.t1_date_livraison) &&
                  this.notToday(orderItem.t1_date_livraison) &&
                  this.notTomorrow(orderItem.t1_date_livraison)
                ) {
                  orderItem.t1_date_livraison = this.date;
                }
                break;
              case 'BLET2':
                if (
                  this.notInPastOrderItem(orderItem.t2_date_livraison) &&
                  this.notToday(orderItem.t2_date_livraison) &&
                  this.notTomorrow(orderItem.t2_date_livraison)
                ) {
                  orderItem.t2_date_livraison = this.date;
                }
                break;
              case 'BLEDN':
                if (
                  this.notInPastOrderItem(orderItem.dn_date_livraison) &&
                  this.notToday(orderItem.dn_date_livraison) &&
                  this.notTomorrow(orderItem.dn_date_livraison)
                ) {
                  orderItem.dn_date_livraison = this.date;
                }
                break;
              case 'BLET3':
                if (
                  this.notInPastOrderItem(orderItem.t3_date_livraison) &&
                  this.notToday(orderItem.t3_date_livraison) &&
                  this.notTomorrow(orderItem.t3_date_livraison)
                ) {
                  orderItem.t3_date_livraison = this.date;
                }
                break;
            }
            this.bleService.saveOrderItem(orderItem).subscribe({
              next: (value) => {},
              error: (err) => console.log(err),
              complete: () => {
                this.farmIds = new Set<number>();
                this.farmIdMapping = new Map<number, string>();
                this.objectList = new Map<number, string>();
              },
            });
          });
        } else if (this.culture === 'orge') {
          parcelToChange = parcel as AROrgeParcel;
          this.orgeService.getOrderItem(parcelToChange.orderItem.id).subscribe((orderItem: AROrgeOrderItem) => {
            switch (this.passage) {
              case 'ORGET2':
                if (
                  this.notInPastOrderItem(orderItem.t2_date_livraison) &&
                  this.notToday(orderItem.t2_date_livraison) &&
                  this.notTomorrow(orderItem.t2_date_livraison)
                ) {
                  orderItem.t2_date_livraison = this.date;
                }
                break;
              case 'ORGET3':
                if (
                  this.notInPastOrderItem(orderItem.t3_date_livraison) &&
                  this.notToday(orderItem.t3_date_livraison) &&
                  this.notTomorrow(orderItem.t3_date_livraison)
                ) {
                  orderItem.t3_date_livraison = this.date;
                }
                break;
            }
            this.orgeService.saveOrderItem(orderItem).subscribe({
              next: (value) => {},
              error: (err) => console.log(err),
              complete: () => {
                this.farmIds = new Set<number>();
                this.farmIdMapping = new Map<number, string>();
                this.objectList = new Map<number, string>();
              },
            });
          });
        } else if (this.culture === 'colza') {
          parcelToChange = parcel as ARColzaParcel;
          this.colzaService.getOrderItem(parcelToChange.orderItem.id).subscribe((orderItem: ARColzaOrderItem) => {
            switch (this.passage) {
              case 'COLZAEH':
                if (
                  this.notInPastOrderItem(orderItem.eh_date_livraison) &&
                  this.notToday(orderItem.eh_date_livraison) &&
                  this.notTomorrow(orderItem.eh_date_livraison)
                ) {
                  orderItem.eh_date_livraison = this.date;
                }
                break;
              case 'COLZASH':
                if (
                  this.notInPastOrderItem(orderItem.sh_date_livraison) &&
                  this.notToday(orderItem.sh_date_livraison) &&
                  this.notTomorrow(orderItem.sh_date_livraison)
                ) {
                  orderItem.sh_date_livraison = this.date;
                }
                break;
            }
            this.colzaService.saveOrderItem(orderItem).subscribe({
              next: (value) => {},
              error: (err) => console.log(err),
              complete: () => {
                this.farmIds = new Set<number>();
                this.farmIdMapping = new Map<number, string>();
                this.objectList = new Map<number, string>();
              },
            });
          });
        }
      });
      this.step = this.stepPlanning.STEP_SELECT_FARMS;
    } else {
      this.objectList.forEach((values, keys) => {
        if (this.culture === 'ble') {
          parcelToChange = this.parcels.find((parcel) => parcel.id === keys) as ARBleParcel;
          this.bleService.getOrderItem(parcelToChange.orderItem.id).subscribe((orderItem: ARBleOrderItem) => {
            switch (this.passage) {
              case 'BLET1':
                if (
                  this.notInPastOrderItem(orderItem.t1_date_livraison) &&
                  this.notToday(orderItem.t1_date_livraison) &&
                  this.notTomorrow(orderItem.t1_date_livraison)
                ) {
                  orderItem.t1_date_livraison = this.date;
                }
                break;
              case 'BLET2':
                if (
                  this.notInPastOrderItem(orderItem.t2_date_livraison) &&
                  this.notToday(orderItem.t2_date_livraison) &&
                  this.notTomorrow(orderItem.t2_date_livraison)
                ) {
                  orderItem.t2_date_livraison = this.date;
                }
                break;
              case 'BLEDN':
                if (
                  this.notInPastOrderItem(orderItem.dn_date_livraison) &&
                  this.notToday(orderItem.dn_date_livraison) &&
                  this.notTomorrow(orderItem.dn_date_livraison)
                ) {
                  orderItem.dn_date_livraison = this.date;
                }
                break;
              case 'BLET3':
                if (
                  this.notInPastOrderItem(orderItem.t3_date_livraison) &&
                  this.notToday(orderItem.t3_date_livraison) &&
                  this.notTomorrow(orderItem.t3_date_livraison)
                ) {
                  orderItem.t3_date_livraison = this.date;
                }
                break;
            }
            this.bleService.saveOrderItem(orderItem).subscribe({
              next: (value) => {},
              error: (err) => console.log(err),
              complete: () => {
                this.getUpdateParcels();
                if (this.changeSomeParcel) {
                  this.parcelIds = new Set<number>();
                  this.parcelIdMapping = new Map<number, string>();
                }
                this.objectList = new Map<number, string>();
              },
            });
          });
        } else if (this.culture === 'orge') {
          parcelToChange = this.parcels.find((parcel) => parcel.id === keys) as AROrgeParcel;
          this.orgeService.getOrderItem(parcelToChange.orderItem.id).subscribe((orderItem: AROrgeOrderItem) => {
            switch (this.passage) {
              case 'ORGET2':
                if (
                  this.notInPastOrderItem(orderItem.t2_date_livraison) &&
                  this.notToday(orderItem.t2_date_livraison) &&
                  this.notTomorrow(orderItem.t2_date_livraison)
                ) {
                  orderItem.t2_date_livraison = this.date;
                }
                break;
              case 'ORGET3':
                if (
                  this.notInPastOrderItem(orderItem.t3_date_livraison) &&
                  this.notToday(orderItem.t3_date_livraison) &&
                  this.notTomorrow(orderItem.t3_date_livraison)
                ) {
                  orderItem.t3_date_livraison = this.date;
                }
                break;
            }
            this.orgeService.saveOrderItem(orderItem).subscribe({
              next: (value) => {},
              error: (err) => console.log(err),
              complete: () => {
                this.getUpdateParcels();
                if (this.changeSomeParcel) {
                  this.parcelIds = new Set<number>();
                  this.parcelIdMapping = new Map<number, string>();
                }
                this.objectList = new Map<number, string>();
              },
            });
          });
        } else if (this.culture === 'colza') {
          parcelToChange = this.parcels.find((parcel) => parcel.id === keys) as ARColzaParcel;
          this.colzaService.getOrderItem(parcelToChange.orderItem.id).subscribe((orderItem: ARColzaOrderItem) => {
            switch (this.passage) {
              case 'COLZAEH':
                if (
                  this.notInPastOrderItem(orderItem.eh_date_livraison) &&
                  this.notToday(orderItem.eh_date_livraison) &&
                  this.notTomorrow(orderItem.eh_date_livraison)
                ) {
                  orderItem.eh_date_livraison = this.date;
                }
                break;
              case 'COLZASH':
                if (
                  this.notInPastOrderItem(orderItem.sh_date_livraison) &&
                  this.notToday(orderItem.sh_date_livraison) &&
                  this.notTomorrow(orderItem.sh_date_livraison)
                ) {
                  orderItem.sh_date_livraison = this.date;
                }
                break;
            }
            this.colzaService.saveOrderItem(orderItem).subscribe({
              next: (value) => {},
              error: (err) => console.log(err),
              complete: () => {
                this.getUpdateParcels();
                if (this.changeSomeParcel) {
                  this.parcelIds = new Set<number>();
                  this.parcelIdMapping = new Map<number, string>();
                }
                this.objectList = new Map<number, string>();
              },
            });
          });
        }
      });
    }
    this.updateModal();
  }

  cancelStepSelectOAD() {
    this.router.navigate(this.planningLink);
    return false;
  }

  cancelStepSelectFarms() {
    this.farmIds = new Set<number>();
    this.farmIdMapping = new Map<number, string>();
    this.date = null;
    this.planningSelectExploitation.resetFilters();
    this.planningSelectExploitation.resetFilterToApply();
    this.step = this.stepPlanning.STEP_SELECT_OAD;
  }

  cancelStepSelectParcel() {
    this.farmIds = new Set<number>();
    this.farmIdMapping = new Map<number, string>();
    this.parcelIds = new Set<number>();
    this.parcelIdMapping = new Map<number, string>();
    this.date = null;
    this.planningSelectParcel.resetFilters();
    this.planningSelectParcel.resetFilterToApply();
    this.step = this.stepPlanning.STEP_SELECT_FARMS;
  }

  cancelStepPicker() {
    this.date = null;
    if (this.isFarm) {
      this.farmIdMapping = new Map<number, string>();
      this.farmIds = new Set<number>();
      this.step = this.stepPlanning.STEP_SELECT_FARMS;
    } else {
      if (this.objectList.size === 1) {
        this.objectList = new Map<number, string>();
        this.parcelIdMapping = new Map<number, string>();
      }
      this.step = this.stepPlanning.STEP_SELECT_PARCEL;
    }
  }

  //Verification front
  isWorkDay() {
    if (this.date) {
      //6 et 0 car 0 correspond au dimanche => Si pas le WeekEnd alors on check les jours fériés
      if (this.date.getDay() !== 6 && this.date.getDay() !== 0) {
        //1er janvier
        if (this.date.getDate() === 1 && this.date.getMonth() === 0) {
          return false;
          //1er mai
        } else if (this.date.getDate() === 1 && this.date.getMonth() === 4) {
          return false;
          //8 mai
        } else if (this.date.getDate() === 8 && this.date.getMonth() === 4) {
          return false;
          //14 juillet
        } else if (this.date.getDate() === 14 && this.date.getMonth() === 6) {
          return false;
          //15 Aout
        } else if (this.date.getDate() === 15 && this.date.getMonth() === 7) {
          return false;
          //1er novembre
        } else if (this.date.getDate() === 1 && this.date.getMonth() === 10) {
          return false;
          //11 novembre
        } else if (this.date.getDate() === 11 && this.date.getMonth() === 10) {
          return false;
          //25 décembre
        } else if (this.date.getDate() === 25 && this.date.getMonth() === 11) {
          return false;

          //fermeture annuelle wanaka
        } else if (this.date.getDate() === 26 && this.date.getMonth() === 11) {
          return false;
        } else if (this.date.getDate() === 27 && this.date.getMonth() === 11) {
          return false;
        } else if (this.date.getDate() === 28 && this.date.getMonth() === 11) {
          return false;
        } else if (this.date.getDate() === 29 && this.date.getMonth() === 11) {
          return false;
        } else if (this.date.getDate() === 30 && this.date.getMonth() === 11) {
          return false;
        } else if (this.date.getDate() === 31 && this.date.getMonth() === 11) {
          return false;

          //lundi de Pâques - à changer chaque année
        } else if (this.date.getDate() === 6 && this.date.getMonth() === 3) {
          return false;
          //jeudi de l'Ascension - à changer chaque année
        } else if (this.date.getDate() === 14 && this.date.getMonth() === 4) {
          return false;
          //lundi de Pentecôte - à changer chaque année
        } else if (this.date.getDate() === 25 && this.date.getMonth() === 4) {
          return false;
        }
        return true;
      } else {
        return false;
      }
      //Si pas de date => non bloquant
    } else {
      return true;
    }
  }

  notInPast() {
    if (this.date) {
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      const time: number = this.date.getTime() - now.getTime();
      return time >= 0;
    }
    return true;
  }

  afterJanuary() {
    if (this.date) {
      const now = new Date();
      let year = now.getFullYear();
      if (now.getMonth() >= 7) {
        year = now.getFullYear() + 1;
      }
      const startCOLZASH = new Date(year, 1, 15);
      return this.date.getTime() - startCOLZASH.getTime() >= 0;
    } else {
      return false;
    }
  }

  notToday(dateOrderItem: any) {
    if (dateOrderItem) {
      const date = new Date(dateOrderItem);
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      return !(
        now.getDate() === date.getDate() &&
        now.getMonth() === date.getMonth() &&
        date.getFullYear() === now.getFullYear()
      );
    }
    return true;
  }

  notTomorrow(dateOrderItem: any) {
    if (dateOrderItem) {
      const date = new Date(dateOrderItem);
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      return !(
        now.getDate() + 1 === date.getDate() &&
        now.getMonth() === date.getMonth() &&
        date.getFullYear() === now.getFullYear()
      );
    }
    return true;
  }

  moreThan3Days() {
    if (!this.date || this.isAdmin) {
      return true;
    } else {
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      const time: number = this.date.getTime() - now.getTime();
      return time >= 259200000;
    }
  }

  notInPastOrderItem(dateOrderItem: any) {
    if (dateOrderItem) {
      const date = new Date(dateOrderItem);
      const now = new Date();
      now.setHours(0);
      now.setMinutes(0);
      now.setSeconds(0);
      now.setMilliseconds(0);
      const time: number = date.getTime() - now.getTime();
      return time > 0;
    }

    return true;
  }

  //Important toujours mois avant le jours car sinon si notre mois actuel a 30 jours ca casse tout !
  isInSeason() {
    if (this.isAdmin) {
      return true;
    } else {
      if (this.date) {
        const now = new Date();
        let year = now.getFullYear();
        if (now.getMonth() >= 7) {
          year = now.getFullYear() + 1;
        }

        if (this.culture === 'ble') {
          switch (this.passage) {
            case 'BLET1':
              const startBLET1 = new Date(year, 0, 1);
              const endBLET1 = new Date(year, 2, 31);
              return this.date.getTime() - startBLET1.getTime() >= 0 && endBLET1.getTime() - this.date.getTime() >= 0;
            case 'BLET2':
              const startBLET2 = new Date(year, 0, 1);
              const endBLET2 = new Date(year, 5, 15);
              return this.date.getTime() - startBLET2.getTime() >= 0 && endBLET2.getTime() - this.date.getTime() >= 0;
            case 'BLEDN':
              const startBLEDN = new Date(year, 2, 14);
              const endBLEDN = new Date(year, 5, 15);
              return this.date.getTime() - startBLEDN.getTime() >= 0 && endBLEDN.getTime() - this.date.getTime() >= 0;
            case 'BLET3':
              const startBLET3 = new Date(year, 2, 14);
              const endBLET3 = new Date(year, 5, 15);
              return this.date.getTime() - startBLET3.getTime() >= 0 && endBLET3.getTime() - this.date.getTime() >= 0;
          }
        } else if (this.culture === 'orge') {
          switch (this.passage) {
            case 'ORGET2':
              const startORGET2 = new Date(year, 0, 1);
              const endORGET2 = new Date(year, 5, 15);
              return this.date.getTime() - startORGET2.getTime() >= 0 && endORGET2.getTime() - this.date.getTime() >= 0;
            case 'ORGET3':
              const startORGET3 = new Date(year, 0, 1);
              const endORGET3 = new Date(year, 5, 15);
              return this.date.getTime() - startORGET3.getTime() >= 0 && endORGET3.getTime() - this.date.getTime() >= 0;
          }
        } else if (this.culture === 'colza') {
          switch (this.passage) {
            case 'COLZAEH':
              const startCOLZAEH = new Date(year, 0, 14);
              const endCOLZAEH = new Date(year, 2, 31);
              return (
                this.date.getTime() - startCOLZAEH.getTime() >= 0 && endCOLZAEH.getTime() - this.date.getTime() >= 0
              );
            case 'COLZASH':
              const startCOLZASH = new Date(year, 1, 15);
              const endCOLZASH = new Date(year, 4, 15);
              return (
                this.date.getTime() - startCOLZASH.getTime() >= 0 && endCOLZASH.getTime() - this.date.getTime() >= 0
              );
          }
        }
        return false;
      } else {
        return true;
      }
    }
  }

  //Modal
  yesModal() {
    this.isFarm = true;
    this.objectList = this.farmIdMapping;
    this.onDatePicker();
    this.step = this.stepPlanning.STEP_PLANNING_PICKER;
  }

  noModal() {
    this.isFarm = false;
    this.step = this.stepPlanning.STEP_SELECT_PARCEL;
  }

  updateModal() {
    const msg = this.i18nTranslator.translate(
      'planning.success',
      this.datepipe.transform(this.date),
      '(' + this.objectListName + ')',
    );
    this.modal.alert(msg);
  }

  //Get dans l'initialisation
  getBleCampaigns(): Observable<ARBleCampaign[]> {
    const obs = this.bleService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsBle = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWhitMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }

  getColzaCampaigns(): Observable<ARColzaCampaign[]> {
    const obs = this.colzaService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsColza = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWhitMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }

  getOrgeCampaigns(): Observable<AROrgeCampaign[]> {
    const obs = this.orgeService.getCampaigns().pipe(share());
    obs.subscribe(
      (campaigns) => {
        this.campaignsOrge = campaigns.sort(Campaign.compare).reverse();
      },
      (err) => this.handleErroWhitMsg(err, this.i18nTranslator.translate('planning.error.campagne')),
    );
    return obs;
  }
}
